export default __webpack_public_path__ + "static/media/saveForm.73b68997.svg";